import {Tab} from 'semantic-ui-react'
import TabPublication from './tabPublication'
import TabProfileJury  from './tabProfileJury'
import TabExperience  from './tabExperience'
import TabEvaluato from './tabEvaluato'
import TabEducation from "./tabEducation";

const TabComponent = ({datos, userState, handleClickTab, changeState, buttonPostulation, handleObservacion, observacionData, handleOpenModal, handleCloseModal, setStatus, status}: any)=> {
    const panes = [
        {
            menuItem: "Perfil de jurado",
            pane: (
                <Tab.Pane attached={false} style={{ border: "none", height: "100%" }}>
                        {" "}
                        <TabProfileJury datos={datos} userState={userState} handleClickTab={handleClickTab} changeState={changeState} buttonPostulation={buttonPostulation} handleObservacion={handleObservacion} observacionData={observacionData} setStatus={setStatus} status={status} />
                </Tab.Pane>
            ),
        },
        {
            menuItem: "Educación",
            pane: (
                <Tab.Pane attached={false} style={{ border: "none", height: "100%" }}>
                    {" "}
                    <TabEducation handleOpenModal={handleOpenModal} handleCloseModal={handleCloseModal} datos={datos} userState={userState} changeState={changeState} buttonPostulation={buttonPostulation} handleObservacion={handleObservacion} observacionData={observacionData}/>
                </Tab.Pane>
            ),
        },
        {
            menuItem: "Experiencia",
            pane: (
                <Tab.Pane
                    attached={false}
                    style={{ border: "none", height: "100%", boxShadow: "none" }}
                >
                    {" "}
                    <TabExperience  handleOpenModal={handleOpenModal} handleCloseModal={handleCloseModal} datos={datos} userState={userState} changeState={changeState} buttonPostulation={buttonPostulation} handleObservacion={handleObservacion} observacionData={observacionData} />
                </Tab.Pane>
            ),
        },
        {
            menuItem: "Reconocimientos y publicaciones",
            pane: (
                <Tab.Pane
                    attached={false}
                    style={{ border: "none", height: "100%", boxShadow: "none" }}
                >
                    {" "}
                    <TabPublication  handleOpenModal={handleOpenModal} handleCloseModal={handleCloseModal} datos={datos} userState={userState} changeState={changeState} buttonPostulation={buttonPostulation} handleObservacion={handleObservacion} observacionData={observacionData}/>
                </Tab.Pane>
            ),
        },
        {
            menuItem: "Observaciones  del evaluador",
            pane: (
                <Tab.Pane
                    attached={false}
                    style={{ border: "none", height: "100%", boxShadow: "none" }}
                >
                    {" "}
                    <TabEvaluato  datos={datos} userState={userState} changeState={changeState} buttonPostulation={buttonPostulation} handleObservacion={handleObservacion} observacionData={observacionData} />
                </Tab.Pane>
            ),
        },
        ];
    return (
        <Tab 

            panes={panes}
            menu={{ secondary: true, pointing: true }}
            className="tabs-jurados"
            renderActiveOnly={false}
        />

    )
}

export default TabComponent